import { Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';

export const AuthRouting: Routes = [
  {
    path: '',
    redirectTo: 'login',
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'login.login' },
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
